<div class="id-resolver-container">
  <ng-container *ngIf="isLoading">
    <div class="spinner"></div>
  </ng-container>

  <ng-container *ngIf="notFound">
    <p>המזהה לא נמצא</p>
  </ng-container>

  <ng-container *ngIf="errorMessage">
    <p>{{ errorMessage }}</p>
  </ng-container>
</div>
